import React from "react";

// mui imports
import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';

// other imports
import CommonModalV2, { modalWidth } from "./commonModal/v2";
import Select from '../subComponents/select'; 
import ModalExitAlert from "./modalExitAlert";
import CallPatientStyle from "../../styles/callPatientStyle";

const SubmitButtonRef = React.createRef();

const MockFunction = () => {};

class CallPatient extends React.Component {
    state = {
        yourPhoneError: false,
        exitModalOpen: false
    }
    componentDidMount() {
        const {
            GetCallPatientDetails = () => {},
            OrderCallSummaryReasons = () => {},
            callSummary = {
                value: -1,
                reasons: []
            },
        } = this.props;
        const data = {
            "DoctorId": localStorage.getItem('userId') && parseInt(localStorage.getItem('userId')),
            "OrderId": this.props.productInfo.OrderId
        };
        GetCallPatientDetails(data);
        if (!callSummary.reasons.length) OrderCallSummaryReasons();
    }

    UNSAFE_componentWillUnmount() {
        let { ResetCallPatientDetails } = this.props;
        ResetCallPatientDetails && ResetCallPatientDetails();
    }

    componentDidUpdate(prevProps) {
        if (this.state.yourPhoneError && this.props.callPatientDetails && this.props.callPatientDetails.DoctorNumber && this.props.callPatientDetails.DoctorNumber.toString().length === 10) {
            this.setState({ yourPhoneError: false })
        }
    }

    onPhoneChange = (e) => {
        let { SetCallPatientDetails } = this.props;
        let { value } = e.target;
        value = value && parseInt(value);
        if ((typeof value === "number" && !isNaN(value)) || value === "") {
            SetCallPatientDetails && SetCallPatientDetails(value);
        }
    }

    onPhoneBlur = (e) => {
        let { value } = e.target;
        value = value && parseInt(value);
        if (!value || value.length !== 10) {
            this.setState({ yourPhoneError: true })
        }
    }

    onCallPatientButtonClick = () => {
        let { CallToPatientPhys = () => {}, callPatientDetails, productInfo = {} } = this.props;
        let data = {
            "DoctorNumber": callPatientDetails.DoctorNumber,
            "OrderId": productInfo.OrderId,
            "StorefrontName": callPatientDetails.StorefrontName,
            "StoreFrontNumber": callPatientDetails.CustomerServiceNumber
        };
        if (SubmitButtonRef && SubmitButtonRef.current) {
            SubmitButtonRef.current.blur && SubmitButtonRef.current.blur();
        }
        CallToPatientPhys(data);
    }

    openAlertModal = () => {
        this.setState({ exitModalOpen: true });
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        const { closeOpenCallPatient = () => {}, ResetCallPatientDetails = () => {}, SetCallSummary = () => {} } = this.props;
        this.setState({ exitModalOpen: false });
        ResetCallPatientDetails();
        closeOpenCallPatient();
        SetCallSummary({ value: -1 });
    }

    handleCallSummaryChange = ({ target }) => {
        const { SetCallSummary = () => {} } = this.props;
        SetCallSummary({ value: target.value });
    }

    handleCloseCallToPatient = async () => {
        const {
            InsertCallSummary = () => {},
            productInfo = {},
            callPatientDetails = {},
            callSummary = {
                value: -1,
                reasons: []
            },
            selectedCardData,
            historyView = false,

            // actions
            GetMedicalOrderNotes = MockFunction,
            GetMedicalPatientNotes = MockFunction,
            GetOrderNotes = MockFunction,
            GetPatientNotes = MockFunction
        } = this.props;
        const { DoctorId = 0 } = selectedCardData;
        const data = {
            OrderId: productInfo.OrderId,
            DoctorId,
            CallSummaryId: parseInt(callSummary.value),
            CallPatient: 1,
            RoomId: callPatientDetails.RoomId
        };
        const response = await InsertCallSummary(data);
        if (response.status === 200) {
            GetMedicalOrderNotes(productInfo);
            !historyView && GetMedicalPatientNotes(productInfo);
            GetOrderNotes(productInfo);
            !historyView && GetPatientNotes(selectedCardData);
        }
        this.onConfirmation();
    }

    render() {
        const {
            openCallPatient,
            classes, isModalAlertOpen,
            SetModalAlertOpen,
            callPatientDetails,
            SetModalTwilioAlertOpen,
            isModalTwilioAlertOpen,
            callSummary = {
                value: -1,
                reasons: []
            },
        } = this.props;

        let OrderCallSummaryReasons = [];
        if (callSummary?.reasons?.length) {
            OrderCallSummaryReasons = callSummary.reasons.map(({ AltItem: value, Description: label }) => ({
                value,
                id: value,
                title: label,
                label
            }));
        }

        return (
            <CommonModalV2
                id="CallPatientModal"
                title="Call Patient From My Phone Line"
                open={openCallPatient}
                style={{ width: modalWidth.l }}
            >
                <div data-view="call-to-patient-component-wrapper" className={classes.modalBody}>
                    <div className={classes.contentWrapperNoAlign}>
                        <div className={classes.orderNote}>This will connect a call from your phone and to the patient's phone. Your number will be masked: the patient's Caller ID will display the Customer Service number below.</div>
                    </div>
                    <div className={`${classes.contentWrapperNoAlign} ${classes.dFLex} ${classes.marginTop10}`}>
                        <div className={classes.mainTitleText}>Your Phone</div>
                        <div className={classes.yourPhoneWrapper}>
                            <input
                                id="YourPhone"
                                name="YourPhone"
                                onChange={this.onPhoneChange}
                                onBlur={this.onPhoneBlur}
                                type="text"
                                maxLength={10}
                                disabled={this.props.callToPatientStatus}
                                className={this.state.yourPhoneError ? classes.textInputError : classes.textInput}
                                value={callPatientDetails && callPatientDetails.DoctorNumber ? callPatientDetails.DoctorNumber : ''}
                            />
                            {
                                !this.state.yourPhoneError ? (
                                    <div className={!this.props.callToPatientStatus ? `${classes.noErrorMessage}` : `${classes.noErrorMessage}`}>
                                        <span className="">10-digit phone number, no spaces (e.g.: 9995551212)</span>
                                    </div>
                                ) : (
                                    <div className={!this.props.callToPatientStatus ? `${classes.errorMessage}` : `${classes.errorMessage}`}>
                                        <span>Phone number must be 10 digits, no spaces  (e.g.: 9995551212)</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className={classes.marginDetails}>
                        <div>
                            <div className={`${classes.orderNote} ${classes.boldText}`} >When communicating with a patient or leaving a voicemail, this order is for:</div>
                        </div>
                        <div>
                            <div className={`${classes.CallPatientDetails}`}>{callPatientDetails && callPatientDetails.StorefrontName}</div>
                        </div>
                    </div>
                    <div className={classes.marginDetails}>
                        <div className={classes.contentWrapper}>
                            <div className={`${classes.orderNote} ${classes.boldText}`}>Patient Support:</div>
                        </div>
                        <div>
                            <div className={`${classes.CallPatientDetails}`}>{callPatientDetails && callPatientDetails.CustomerServiceNumber}</div>
                        </div>
                    </div>
                    {this.props.callToPatientStatus && <div className={classes.marginDetails}>
                        <div className={`${classes.boldText} ${classes.ConnectionMessage}`}>Call initiated to your phone listed above...</div>
                    </div>}
                    {!this.props.callToPatientStatus ?
                        <div className={classes.modalActionWrapper}>
                            <Button
                                disabled={callPatientDetails.DoctorNumber && callPatientDetails.DoctorNumber.toString().length === 10 ? false : true}
                                onClick={this.onCallPatientButtonClick}
                                ref={SubmitButtonRef}
                                variant="contained"
                                color="primary"
                                id="callToPatientButton"
                                className={classes.buttonStyleWithMarginRight}
                            >
                                Call
                            </Button>
                            <Button
                                onClick={this.openAlertModal}
                                variant="contained"
                                color="primary"
                                id="cancalCallToPatientButton"
                                className={classes.cancelButtonStyle}
                            >
                                Cancel
                            </Button>
                        </div> :
                        <div className={classes.modalCloseWrapper}>
                            <div className="call-summary-wrapper">
                                <div className={classes.mainTitleText}>Call Summary</div>
                                <Select
                                    id="select-call-summary"
                                    labelId="call-summary"
                                    value={callSummary.value}
                                    onChange={this.handleCallSummaryChange}
                                    items={OrderCallSummaryReasons}
                                />
                            </div>
                            <div className="call-summary-close-wrapper">
                                <Button
                                    disabled={callSummary.value === -1}
                                    onClick={this.handleCloseCallToPatient}
                                    variant="contained"
                                    color="primary"
                                    id="closeCallToPatientButton"
                                    className={classes.buttonStyle}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>}
                </div>
                <ModalExitAlert type="confirmation" onConfirmation={this.onConfirmation} modalOpen={this.state.exitModalOpen} closeModal={this.closeAlertModal} />
                <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
                <ModalExitAlert type="twilio" modalOpen={isModalTwilioAlertOpen} closeModal={() => SetModalTwilioAlertOpen(false)} />
            </CommonModalV2>
        )
    }
}


export default withStyles(CallPatientStyle)(CallPatient);

